import React, { useEffect, useRef } from 'react'
import '../css/logo.css';
import theme from '../theme';

const markerSearching = "https://res.cloudinary.com/wikimenu/image/upload/v1691719284/store-app/signt-r_dolsbm.png"


export default function MarkerSight(props) {
  
   const {googleMap, onUpdateCenter, show} = props; 
   //console.debug("MarkerSight");   
  
   const markerSight = useRef(null);  
   const listener = useRef(null)
   
   useEffect(() => {
      

      if (markerSight.current){         
          markerSight.current.setMap(null);
      }

      if(listener.current){
         window.google.maps.event.removeListener(listener.current)
         //console.debug("useEffect removeListener");
      }

      if(show){
         const center =googleMap.current.getCenter();
         markerSight.current =  new window.google.maps.Marker({         
            position: center,
            icon:markerSearching   
         });
         markerSight.current.setMap(googleMap.current);
         listener.current = setupListener()
         //console.debug("useEffect addListener");
      }


    }, [show]);


    const setupListener=()=>{
      return window.google.maps.event.addListener(googleMap.current, 'center_changed', ()=> {    
         const center =googleMap.current.getCenter();
         markerSight.current.setPosition(center); 
         handlerUpdateCenter(center); 
   }); 
   }  
   

   const handlerUpdateCenter = (center)=>{
      if(onUpdateCenter){
         onUpdateCenter({
            latitude:center.lat(), 
            longitude:center.lng()
         })
      }
   }

   return (
      ""
   )
}
